"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signNft = void 0;
var types_1 = require("@rarible/types");
var ethereum_provider_1 = require("@rarible/ethereum-provider");
var eip712_1 = require("./eip712");
function signNft(ethereum, chainId, nft) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, domain_1, data_1, _b, domain, data, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = nft['@type'];
                    switch (_a) {
                        case "ERC721": return [3 /*break*/, 1];
                        case "ERC1155": return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1:
                    domain_1 = createEIP712NftDomain(chainId, nft.contract, "ERC721");
                    data_1 = {
                        types: eip712_1.EIP721_NFT_TYPES,
                        domain: domain_1,
                        primaryType: eip712_1.EIP721_NFT_TYPE,
                        message: __assign(__assign({}, nft), { tokenURI: nft.uri }),
                    };
                    _b = types_1.toBinary;
                    return [4 /*yield*/, ethereum_provider_1.signTypedData(ethereum, data_1)];
                case 2: return [2 /*return*/, _b.apply(void 0, [_d.sent()])];
                case 3:
                    domain = createEIP712NftDomain(chainId, nft.contract, "ERC1155");
                    data = {
                        types: eip712_1.EIP1155_NFT_TYPES,
                        domain: domain,
                        primaryType: eip712_1.EIP1155_NFT_TYPE,
                        message: __assign(__assign({}, nft), { tokenURI: nft.uri }),
                    };
                    _c = types_1.toBinary;
                    return [4 /*yield*/, ethereum_provider_1.signTypedData(ethereum, data)];
                case 4: return [2 /*return*/, _c.apply(void 0, [_d.sent()])];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.signNft = signNft;
function createEIP712NftDomain(chainId, verifyingContract, nftType) {
    switch (nftType) {
        case "ERC721": {
            return __assign(__assign({}, eip712_1.EIP721_DOMAIN_NFT_TEMPLATE), { chainId: chainId, verifyingContract: verifyingContract });
        }
        case "ERC1155": {
            return __assign(__assign({}, eip712_1.EIP1155_DOMAIN_NFT_TEMPLATE), { chainId: chainId, verifyingContract: verifyingContract });
        }
    }
}
